import SpaceBetween from '@risk-smart/themed-cloudscape-components/space-between';
import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledInput } from '@/components/form/controlled-input/ControlledInput';
import ControlledTextarea from '@/components/form/controlled-textarea';

import type { BaseConnectionData } from './EnterpriseConnectionSchema';

interface BaseProps {
  control: Control<BaseConnectionData>;
  isDisabled?: boolean;
}

export const DomainField: FC<
  BaseProps & { label: string; description: string; placeholder: string }
> = ({ control, isDisabled, label, description, placeholder }) => (
  <ControlledInput
    name={'Domain'}
    label={label}
    description={description}
    control={control}
    placeholder={placeholder}
    disabled={isDisabled}
    forceRequired
  />
);

export const ClientCredentialsFields: FC<
  BaseProps & { providerLabel?: string }
> = ({ control, isDisabled, providerLabel }) => {
  const { t } = useTranslation('common', { keyPrefix: 'sso' });
  const clientIdDescription = providerLabel
    ? t('clientId.descriptionWithProvider', { provider: providerLabel })
    : t('clientId.description');
  const clientSecretDescription = providerLabel
    ? t('clientSecret.descriptionWithProvider', { provider: providerLabel })
    : t('clientSecret.description');

  return (
    <>
      <ControlledInput
        name={'ClientId'}
        label={t('clientId.label')}
        description={clientIdDescription}
        placeholder={t('clientId.placeholder')}
        control={control}
        disabled={isDisabled}
        forceRequired
      />
      <ControlledInput
        name={'ClientSecret'}
        label={t('clientSecret.label')}
        description={clientSecretDescription}
        control={control}
        type={'password'}
        disabled={isDisabled}
        forceRequired
      />
    </>
  );
};

export const LoginExperienceSection: FC<BaseProps> = ({
  control,
  isDisabled,
}) => {
  const { t } = useTranslation('common', { keyPrefix: 'sso' });

  return (
    <div className={'mt-2'}>
      <p className={'text-sm font-medium text-grey600 mb-4'}>
        {t('domainRoutingTitle')}
      </p>
      <SpaceBetween direction={'vertical'} size={'l'}>
        <ControlledTextarea
          name={'IdentityProviderDomains'}
          label={t('identityProviderDomains.label')}
          description={t('identityProviderDomains.description')}
          control={control}
          placeholder={t('identityProviderDomains.placeholder')}
          disabled={isDisabled}
          forceRequired
        />
      </SpaceBetween>
    </div>
  );
};
